import { useCallback, useMemo, useState } from "react";
import { TABLE_SEARCH_FILTER_KEY } from "../CategoryLeadersTableTop.types";
import { createTableSearchFilter } from "../CategoryLeadersTableTopUtils";

export const useTableSearch = () => {
    const [searchTerm, setSearchTerm] = useState(null);

    const searchFilter = useMemo(() => {
        return createTableSearchFilter(TABLE_SEARCH_FILTER_KEY, searchTerm);
    }, [searchTerm]);

    const onSearch = useCallback(
        (search: string) => {
            setSearchTerm(search);
        },
        [setSearchTerm],
    );

    return {
        searchFilter,
        onSearch,
    };
};
